module.exports = __webpack_public_path__ + "img/10S.b208cd7f.png";